import React from 'react';
import { Api } from '../api';
import ProjectList from './ProjectList';
import ScribeNotification from './ScribeNotification';
import { Button, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { Fetch } from '../api';

// this component does not use the redux store. if it gets more complicated it should
export default class ProjectIndex extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      projects: this.props.projects || [],
      userProjects: this.props.user_projects || [],
      userId: this.props.user_id,
      userName: this.props.user_name,
      orgName: this.props.org_name,
      orgId: this.props.org_id,
      noMore: false,
      error: false,
      activeTab: (this.props.user_projects && this.props.user_projects.length > 0) ? 1 : 2,
    };
  }

  removeProject = (id) => {
    Fetch.delete(`/wfdw/projects/${id}`, {}, false);
    this.setState({
      projects: this.state.projects.filter(project => project.id !== id),
      userProjects: this.state.userProjects.filter(project => project.id !== id),
    });
  }

  fetchMore = (prType) => {
    const lastItem = this.state[prType][this.state[prType].length - 1];
    const queries = [`org=${this.state.orgId}`];
    if (lastItem) { queries.push(`last=${lastItem.id}`); }
    if (prType === 'userProjects') { queries.push(`user_id=${this.state.userId}`); }
    const query = queries.join('&');

    Api.get(`/api/projects?${query}`).then((json) => {
      this.applyMore(prType, json);
    }).catch((err) => {
      this.setState({ error: true });
    });
  }

  applyMore = (prType, more) => {
    if (more.length > 0) {
      const newState = {};
      newState[prType] = this.state[prType].concat(more);
      this.setState(newState);
    } else {
      this.setState({ noMore: true });
    }
  }

  toggleNoMore = () => {
    this.setState({ noMore: !this.state.noMore });
  }

  toggleError = () => {
    this.setState({ error: !this.state.error });
  }

  selectTab = (tabID) => {
    this.setState({ activeTab: tabID });
  }

  yourProjectTabNav(){
    if (this.state.userProjects.length > 0){
      return(
        <NavItem>
          <NavLink
            className={"project-index-tab " + (this.state.activeTab == 1 ? 'active' : '')}
            onClick={() => this.selectTab(1)}
            role="tab"
          >
            {this.state.userName} Projects
          </NavLink>
        </NavItem>
      );
    }
  }
  yourProjectTabContents(){
    if (this.state.userProjects.length > 0){
      return(
        <TabPane tabId={1} className="project-index" key='group01'>
          <ProjectList
            key={`user-projects-${this.state.userProjects.length}`}
            projects={this.state.userProjects}
            removeProject={this.removeProject}
            skipOwner={true}
          />
          <Button className="project-index-more" onClick={() => this.fetchMore('userProjects')} color="primary">
            Show More
          </Button>
        </TabPane>
      );
    }
  }

  newProjectButton(){
    return(
      <div className="float-end">
        <Button color="primary" href="/wfdw/projects/new?skip_wizard=true"><i className="fa fa-plus " aria-hidden="true"></i> New Project</Button>
        <Button color="primary" href="/wfdw/projects/new"><i className="fa fa-magic " aria-hidden="true"></i> (Guided)</Button>
      </div>
    );
  }



  render() {
    return (<div>
      {this.newProjectButton()}
      <Nav tabs>
        {this.yourProjectTabNav()}
        <NavItem>
          <NavLink
            className={"project-index-tab " + (this.state.activeTab == 2 ? 'active' : '')}
            onClick={() => this.selectTab(2)}
            role="tab"
          >
            {this.state.orgName} Projects
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={this.state.activeTab}>
        {this.yourProjectTabContents()}
        <TabPane tabId={2} className="project-index" key='group02'>
          <ProjectList
            key={`org-projects-${this.state.projects.length}`}
            projects={this.state.projects}
            removeProject={this.removeProject}
          />
          <Button className="project-index-more" onClick={() => this.fetchMore('projects')} color="primary">
            Show More
          </Button>
        </TabPane>
      </TabContent>
      <ScribeNotification
        isActive={this.state.noMore}
        message={'No more projects left to load.'}
        action={'close'}
        onClick={this.toggleNoMore}
      />
      <ScribeNotification
        isActive={this.state.error}
        error
        message={'Error loading more projects. Please try again in a moment.'}
        action={'close'}
        onClick={this.toggleError}
      />
    </div>);
  }
}
